import React, { FC } from 'react';
import { TableBody, TableCell, TableRow } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';
import { EnergyGrade } from 'enova-frontend-components';

import {
  AccentedTableRow,
  LeftBorderCell,
  StyledTable
} from '../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface MerkeArealProps {
  energiKarakter: EnergyGrade | undefined;
  totalBRA: number | undefined;
  totalOppvarmetBRA: number | undefined;
}
export const MerkeArealView: FC<MerkeArealProps> = ({ energiKarakter, totalBRA, totalOppvarmetBRA }) => {
  const { t } = useTranslation();

  if (!energiKarakter || totalBRA || totalOppvarmetBRA) {
    return null;
  }

  return (
    <StyledTable>
      <TableBody>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('register.summary.header.merkeAreal')}</TableCell>
        </AccentedTableRow>
        <TableRow>
          <TableCell>{t('energyLabel.energyGrade')}</TableCell>
          <LeftBorderCell>{energiKarakter.toUpperCase()}</LeftBorderCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('register.summary.result.bruksAreal')}</TableCell>
          <LeftBorderCell>{totalBRA ? `${totalBRA} ${t('suffix.m2')}` : `0 ${t('suffix.m2')}`}</LeftBorderCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('register.summary.result.oppvarmetAreal')}</TableCell>
          <LeftBorderCell>
            {totalOppvarmetBRA ? `${totalOppvarmetBRA} ${t('suffix.m2')}` : `0 ${t('suffix.m2')}`}
          </LeftBorderCell>
        </TableRow>
      </TableBody>
    </StyledTable>
  );
};
